import { CommonServiceIds, IHostNavigationService, ILocationService } from "azure-devops-extension-api";
import { CoreRestClient } from "azure-devops-extension-api/Core";
import * as SDK from 'azure-devops-extension-sdk';

export class CommonService {
    /**
     *
     */
    constructor() {
    }

    static async goToProjectSettings() {
        const navigationService = await SDK.getService<IHostNavigationService>(
            CommonServiceIds.HostNavigationService
        );
        const pageRoute = await navigationService.getPageRoute();
        const project = pageRoute.routeValues["project"];

        const locationService = await SDK.getService<ILocationService>(
            CommonServiceIds.LocationService
        );
        const hostBaseUrl = await locationService.getResourceAreaLocation(
            CoreRestClient.RESOURCE_AREA_ID
        );

        navigationService.openNewWindow(`${hostBaseUrl}${project}/_settings/Intriq.ogg-4-ado.ogg-config-hub`, '');
    }
}

